import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Col, Container, Row } from 'reactstrap'

// Import Background Image
import Img1 from '../assets/images/about/img-1.png'
import Img2 from '../assets/images/about/img-2.png'

//import icon
import FeatherIcon from 'feather-icons-react'

export default class About extends Component {
	render() {
		return (
			<React.Fragment>
				<section className='section' id='about'>
					<Container>
						<Row className='justify-content-center'>
							<Col lg={7}>
								<div className='text-center mb-5'>
									<h2 className=''>About Us</h2>
									<p className='text-muted'>
										Tapio is a dynamic tech company dedicated to crafting
										comprehensive end-to-end software solutions specifically
										designed for B2B clients. Our innovative approach and
										commitment to excellence enable businesses to streamline
										operations and achieve their strategic objectives. Discover
										how Tapio can transform your business with tailored
										solutions that drive success.
									</p>
								</div>
							</Col>
						</Row>
					</Container>
				</section>
			</React.Fragment>
		)
	}
}
